import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython, faNodeJs } from '@fortawesome/free-brands-svg-icons';
import { faDatabase, faShieldHalved } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "React",
    "Next.js",
    "TypeScript",
    "JavaScript",
    "Python",
    "Golang",
    "FastAPI",
    "Django",
    "Node.js",
    "NestJS",
    "TailwindCSS",
];

const labelsSecond = [
    "Git",
    "GitHub Actions",
    "Azure DevOps",
    "Docker",
    "AWS",
    "Azure",
    "CI/CD",
    "TDD",
];

const labelsThird = [
    "LLM Integration",
    "RAG Systems",
    "LangChain",
    "Langfuse",
    "Prompt Engineering",
    "OpenAI",
    "VectorDB",
];

const labelsFourth = [
    "Microservices",
    "REST APIs",
    "API Gateway",
    "Golang",
    "Node.js",
    "NestJS",
    "FastAPI",
    "Django",
    "Redis",
];

const labelsFifth = [
    "PostgreSQL",
    "MySQL",
    "MongoDB",
    "Redis",
    "NoSQL",
    "VectorDB",
    "Prisma",
];

const labelsSixth = [
    "SIEM",
    "Secure Programming",
    "Offensive Security",
    "Network Security",
    "Penetration Testing",
    "Vulnerability Assessment",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>Full Stack Web Development</h3>
                    <p>I have built scalable full-stack applications across startups and enterprise environments using React, Next.js, Django, FastAPI, Node.js, and Golang — from CRM platforms to microservice architectures.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>DevOps & Cloud Infrastructure</h3>
                    <p>I have led cloud migrations to Azure, built CI/CD pipelines with GitHub Actions and Azure DevOps, and containerised services with Docker — enabling automated, reliable deployments with robust protection policies.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>AI / LLM & RAG Systems</h3>
                    <p>I design and build agentic LLM systems and Retrieval-Augmented Generation (RAG) pipelines, delivering accurate, context-aware AI responses. Experienced with LangChain, Langfuse, OpenAI, and vector databases in production.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faNodeJs} size="3x"/>
                    <h3>Microservices & Backend</h3>
                    <p>I architect and build distributed microservice systems backed by API gateways and message queues. Experienced designing third-party data processing systems and real-time search engines with privilege-based access control.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFourth.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDatabase} size="3x"/>
                    <h3>Databases & Storage</h3>
                    <p>I design and manage relational, document, and vector databases for production systems — from structured SQL schemas to NoSQL and vector stores powering AI-driven applications.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFifth.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faShieldHalved} size="3x"/>
                    <h3>Cybersecurity</h3>
                    <p>Currently pursuing a Master of Cyber Security at the University of Adelaide, with hands-on experience in SIEM, secure programming, offensive security, and stateful black-box fuzzing of embedded systems.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Domains:</span>
                        {labelsSixth.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;
